export default __webpack_public_path__ + "static/media/logo.0dd9a510.png";